import React from 'react';
import Icon from '../../../components/AppIcon';

const CategorySection = ({ title, description, icon, itemCount, locked = true }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-200 cursor-pointer group">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-secondary/20 rounded-lg flex items-center justify-center group-hover:bg-primary/10 transition-colors duration-200">
            <Icon name={icon} size={20} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground">{itemCount} resources</p>
          </div>
        </div>
        {locked && (
          <Icon name="Lock" size={18} color="var(--color-muted-foreground)" />
        )}
      </div>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
};

export default CategorySection;